
import {
  experience,
  loadbalancer,
  popularServices,
  questions,
} from "~/data/network";
import Modal from "~/components/rebranding/modal/Modal.vue";
import SolutionCols from "~/components/network/SolutionCols.vue";

export default {
  data() {
    return {
      copiedIndex: null,
      activeSection: "",
      FormTitle: "",
      solotionTab: 0,
      experience,
      loadbalancer,
      popularServices,
      questions,
      quickSections: [
        { id: "experience", label: "تضمین دسترسی پایدار" },
        { id: "loadbalancer", label: "لود بالانسر" },
        { id: "sni", label: "تحریم‌شکن" },
        { id: "support", label: "تماس با متخصصان" },
        { id: "solutions", label: "راهکارها" },
        { id: "popular-services", label: "خدمات پرکاربرد" },
        { id: "faq", label: "سوالات متداول" },
      ],
    };
  },
  components: {
    Modal,
    SolutionCols,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "شبکه ابری آبالون | لود بالانسر و تحریم‌شکن",
      meta: [
        {
          name: "description",
          content:
            "شبکه ابری آبالون | لود بالانسر هوشمند و تحریم‌شکن اختصاصی | توزیع پایدار ترافیک و دسترسی آزاد به منابع بین‌المللی | اتصال امن و سریع",
        },
        {
          name: "keywords",
          content: "شبکه ابری آبالون, لود بالانسر آبالون, راهکار تحریم شکن",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/network",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "شبکه ابری آبالون | لود بالانسر و تحریم‌شکن",
        },
        {
          property: "og:description",
          content:
            "شبکه ابری آبالون | لود بالانسر هوشمند و تحریم‌شکن اختصاصی | توزیع پایدار ترافیک و دسترسی آزاد به منابع بین‌المللی | اتصال امن و سریع",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/network",
        },
        {
          name: "twitter:title",
          title: "شبکه ابری آبالون | لود بالانسر و تحریم‌شکن",
        },
        {
          name: "twitter:description",
          content:
            "شبکه ابری آبالون | لود بالانسر هوشمند و تحریم‌شکن اختصاصی | توزیع پایدار ترافیک و دسترسی آزاد به منابع بین‌المللی | اتصال امن و سریع",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/network",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "شبکه ابری آبالون شامل چه سرویس‌هایی می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "شبکه ابری آبالون شامل دو سرویس کلیدی است: لود بالانسر هوشمند برای توزیع پایدار ترافیک و تحریم‌شکن اختصاصی برای دسترسی مستقیم به منابع بین‌المللی.",
                },
              },
              {
                "@type": "Question",
                name: "چه سازمان‌هایی به سرویس لودبالانسر آبالون نیاز دارند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "کسب‌وکارهایی با چند سرور در هر جای ایران و جهان که سرویس‌های پرترافیک دارند (مانند وب‌سایت‌های پربازدید، اپلیکیشن‌های آنلاین و سامانه‌های دولتی) یا پلتفرم‌های تجارت الکترونیک که حتی چند دقیقه قطعی برایشان خسارت‌بار است، به یک راهکار توزیع بار نیاز دارند. لود بالانسر آبالون با توزیع هوشمند ترافیک، از کندی یا قطع سرویس جلوگیری کرده و پایداری زیرساخت شما را تضمین می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "چه نوع سازمان‌هایی بیشترین بهره را از شبکه ابری آبالون می‌برند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سازمان‌های پرترافیک، پلتفرم‌های SaaS و Cloud، تیم‌های DevOps و همچنین شرکت‌هایی که نیازمند دسترسی پایدار به منابع بین‌المللی هستند، بیشترین ارزش را از شبکه ابری آبالون دریافت می‌کنند.",
                },
              },
              {
                "@type": "Question",
                name: "برای استفاده از سرویس تحریم‌شکن آبالون چه پیش‌نیازهایی لازم است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرویس تحریم‌شکن آبالون روی تمام سرویس‌های زیرساختی آبالون فعال است. تنها کافی است IPهای اختصاص‌داده‌شده را در تنظیمات DNS سرویس‌های خود وارد کنید و بدون نیاز به تغییرات پیچیده، به منابع بین‌المللی متصل شوید.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "شبکه ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein Moayeri",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
